module.exports = __webpack_public_path__ + "img/remove-watchlist.6fe812cb.svg";